import { Pivot, PivotItem } from '@fluentui/react';
import { Stack } from '@fluentui/react/lib/Stack';
import React from "react";
import { useLocation } from 'react-router';
import { SearchFor } from '../../models/Search/ISearchFor';
import { Accounts } from "../Accounts/Account";
import { Quotation } from "../Quotes/Quotation";


const stackTokens = { childrenGap: 10 };
export const SearchResult: React.FunctionComponent = () => {

    const location = useLocation();
    const SearchFor: SearchFor | undefined = location.state as SearchFor | undefined;

    return (
        <Stack
            style={{
                marginLeft: "30px",
                marginRight: "30px",
            }}
            tokens={stackTokens}
        >
            <h3 style={{ marginBottom: "2px" }}>Search Result</h3>
            <p style={{ marginTop: "0px" }}>Showing results for <b>'{SearchFor && SearchFor.searchText}'</b></p>

            <Pivot aria-label="Accounts">
                <PivotItem headerText="Accounts" >
                    <Accounts />
                </PivotItem>
                <PivotItem headerText="Quotations">
                    <Quotation />
                </PivotItem>
            </Pivot>
        </Stack>
    );
}